<template>
  <v-row>
    <v-col>
      <v-menu
        ref="datepicker"
        :close-on-content-click="false"
        v-model="datepicker"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :rules="[validDate]"
            v-model="date"
            label="Händelsedatum"
            :disabled="disabled"
            outlined
            v-bind="attrs"
            v-on="on"
            hint="Obligatorisk"
            persistent-hint
          />
        </template>
        <v-date-picker
          locale="sv"
          first-day-of-week="1"
          v-model="date"
          no-title
          @input="datepicker = false"
        />
      </v-menu>
    </v-col>
    <v-col cols="4">
      <v-text-field
        :rules="[validTime]"
        v-model="time"
        :disabled="disabled"
        type="time"
        label="Händelsetid"
        outlined
        hint="Obligatorisk"
        persistent-hint
      />
    </v-col>
  </v-row>
</template>

<script>
import { format } from 'date-fns'
import { get } from 'vuex-pathify'
import { validDate, validTime } from '@/common/validationRules'

export default {
  name: 'EventTimeStartField',

  props: {
    disabled: Boolean
  },

  data: () => ({
    validDate,
    validTime,
    date: null,
    time: null,
    datepicker: false
  }),

  computed: {
    time_start: get('event/model@time_start')
  },

  created() {
    const timeStart = this.time_start
    this.date = format(timeStart, 'yyyy-MM-dd')
    this.time = format(timeStart, 'HH:mm')
  },

  watch: {
    date(input) {
      const timeStart = new Date(`${input} ${this.time}`)
      this.$store.set('event/model@time_start', timeStart)
    },

    time(input) {
      const timeStart = new Date(`${this.date} ${input}`)
      this.$store.set('event/model@time_start', timeStart)
    }
  }
}
</script>
